// @core/api/endpoints/knowledge/update_knowledge_base.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  KnowledgeBaseResponse,
  UpdateKnowledgeBaseRequest,
} from '../../../types/knowledge';

const BASE_PATH = '/knowledge';

/**
 * Update knowledge base
 * Updates a knowledge base's name, description, status, or chunking settings. The embedding model cannot be changed — create a new base instead.
 */
export async function UpdateKnowledgeBase(
  base_id: string,
  data: UpdateKnowledgeBaseRequest,
  options?: RequestOptions
): Promise<KnowledgeBaseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/knowledge/bases/:base_id`;
  requestPath = requestPath.replace(':base_id', encodeURIComponent(base_id));
  const requestOptions = options;
  return client.patch<KnowledgeBaseResponse>(requestPath, data, requestOptions);
}
